class ProductItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setInputEvent();
    this.setCompareStatus();
    const cardCompare = this.querySelector('.card-compare');
    if(cardCompare) {
      cardCompare.addEventListener("click", this.handlecCompareClick.bind(this));
      document.addEventListener("compare-action-updade", () => {
        this.setCompareStatus();
      });
    }
  }
  setCompareStatus() {
    const productId = $(this).data('id');
    const ids = JSON.parse(localStorage.getItem('compares') || '[]');
    const idx = ids.indexOf(productId);
    if(idx != -1) {
      this.querySelector('.card-compare')?.classList.add("active");
    } else {
      this.querySelector('.card-compare')?.classList.remove("active");
    }
  }
  handlecCompareClick(event) {
    event.stopPropagation();
    const productId = $(this).data('id');
    const ids = JSON.parse(localStorage.getItem('compares') || '[]');
    const idx = ids.indexOf(productId);
    let max_compare_num = 3;
    if(window.innerWidth < 750) {
      max_compare_num = 2;
    }
    if(idx != -1) { // 存在, 取消
      ids.splice(idx, 1)
      localStorage.setItem('compares', JSON.stringify(ids));
      this.querySelector('.card-compare').classList.toggle("active");
      $('product-compare-footer').attr('compare-list', ids);
    } else if(ids.length < max_compare_num) { // 不存在, 对比小于3
      ids.push(productId)
      localStorage.setItem('compares', JSON.stringify(ids));
      this.querySelector('.card-compare').classList.toggle("active");
      $('product-compare-footer').attr('compare-list', ids);
    } else { // 不存在 大于等于3 不让存, 提示
      alert('Comparison quantity exceeds limit')
    }
  }
  setInputEvent() {
    const variantInputs = this.querySelectorAll('.color-swatch__radio'); // 获取所有 input
    const mediaContainer = this.querySelector('.media'); // 获取图片容器
    const mediaImages = mediaContainer.querySelectorAll('img'); // 获取容器内所有图片
    variantInputs.forEach(input => {
      input.addEventListener('click', () => {
        // 获取点击的 input 的 data-variant-featured-media
        const targetMediaId = input.dataset.variantFeaturedMedia;

        // 找到匹配的图片
        const targetImg = Array.from(mediaImages).find(
          img => img.dataset.mediaId === targetMediaId
        );

        if (targetImg) {
          // 将目标图片移动到第一个位置
          mediaContainer.prepend(targetImg);
        }
      });
    });
  }
}

customElements.define("product-item", ProductItem);
